import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import voiceAgentReducerBase from './voiceAgentReducer';

// Only `callActivityLogOutcomeFilter` is persisted here — everything else on
// this slice is fetched report data that must NOT survive a refresh/relogin
// (see the root persistConfig's `whitelist: ['auth']` in store.ts, which
// deliberately excludes this slice from the top-level persist blob). This
// nested persistReducer manages its own separate storage entry under the
// 'voiceAgent' key, independent of the root persistor, so only the one
// small filter value round-trips through localStorage. It's still wiped on
// logout: RESET_REPORTS_DATA (rootReducer.ts) sets this slice to `undefined`,
// combineReducers reinitializes it to initialState (filter back to 'all'),
// and this persistReducer's own subscription picks up that new state and
// re-persists it, so a stale filter can't survive into the next account.
const persistedVoiceAgentReducer = persistReducer(
  { key: 'voiceAgent', storage, whitelist: ['callActivityLogOutcomeFilter'] },
  voiceAgentReducerBase,
);

export { persistedVoiceAgentReducer as voiceAgentReducer };
export { default as voiceAgentSaga } from './voiceAgentSaga';
